import * as React from "react";
import {Header} from "@/components/Header";
import {t} from "i18next";

export const Pride = () => {
	return (
		<>
			<div
				className={
					"w-[100vw] bg-white flex flex-col items-center justify-center"
				}
			>
				<Header/>
				<img
					src="/banners/banner-abhiman.jpg"
					alt=""
					className="w-full object-cover shadow-lg"
				/>
				<h1 className={"text-[5vw] font-custom-mono-bold"}>{t("CONSTANTS.COMING_SOON")}</h1>
			</div>

		</>
	);
};
